import { type PageType } from 'src/shared/enums/pageType';
import { type Product } from 'src/shared/types';

import {
    GA4EventName,
    type GA4FeatureCategory,
    type GA4ItemListName,
    type GA4ItemListType,
    type Product as TrackingProduct,
} from '@jsmdg/tracking';
import { type TrackingListName } from '../enums';
import { featureCategoryMap, itemListNameMap, trackingProductTypeMap } from './maps';

export function getProductTrackingData(
    product: Product,
    position: number,
    pageType: PageType | undefined,
    trackingListName: TrackingListName | undefined,
): {
    product: TrackingProduct;
    position: number;
    featureCategory?: GA4FeatureCategory;
    itemListName?: GA4ItemListName;
    eventName: GA4EventName;
    itemListType?: GA4ItemListType;
} {
    const {
        discountBadge,
        locations,
        manufacturerSku,
        originalPrice,
        participants,
        price,
        productId,
        productType,
        rating,
        title,
        trackingPath,
        url,
    } = product;

    return {
        product: {
            id: productId,
            productType: trackingProductTypeMap[productType],
            title,
            trackingPath,
            trackingName: title,
            url: pageType?.startsWith('redemption') ? `/einloesen/${productId}` : url,
            manufacturerSku,
            price: price && {
                gross: {
                    amount: Number.parseFloat(price.gross.amount),
                    currencyCode: price.gross.currencyCode,
                },
            },
            originalPrice: originalPrice && {
                gross: {
                    amount: Number.parseFloat(originalPrice.gross.amount),
                    currencyCode: originalPrice.gross.currencyCode,
                },
            },
            discountBadgeId: discountBadge?.id,
            discountBadgeName: discountBadge?.text,
            locationCount: locations?.length,
            rating: rating
                ? {
                      value: rating.value,
                      count: rating.count,
                  }
                : undefined,
            participants: participants
                ? {
                      min: participants.min,
                      max: participants.max,
                  }
                : undefined,
        },
        position,
        featureCategory: pageType ? featureCategoryMap[pageType] : undefined,
        itemListName: trackingListName ? itemListNameMap[trackingListName] : undefined,
        eventName: GA4EventName.ViewItemList,
    };
}
